import React from 'react';
import { observer } from "mobx-react";
import { Link } from "react-router-dom";


interface Props {
    arDataProduct: [],
}


@observer
export class EmptyImageProducts extends React.Component<Props, {}> {

    render() {
        const { arDataProduct } = this.props;

        return (
            <>
                <div className="user-list-topline no-space-between">
                    <div className="td2-3" style={{ width: '70%' }}>
                        <span className="basket-item-top-line__text">Наименование</span>
                    </div>
                     <div className="td2-3" >
                        <span className="basket-item-top-line__text">Бренд</span>
                    </div>
                    <div className="td2-4">
                        <span className="basket-item-top-line__text">ШК</span>
                    </div>
                    <div className="td2-2"  >
                        <span className="basket-item-top-line__text" >Артикул</span>
                    </div>
                    <div className="td2-5">
                        <span className="basket-item-top-line__text">Ссылка</span>
                    </div>
                </div>
                <div className="user-list">
                    {arDataProduct.length ? arDataProduct.map((item: any, index: number) => (
                        <>
                            <div key={index} className={"user-list-item"}>
                                <div className="td2-3 list-item-border" style={{ width: '63%' }}>
                                    <div className="client-mobile-title">Наименование</div>
                                    <span
                                        className="list-item-text__normal">{item.name}</span>
                                </div>
                                   <div className="td2-3 list-item-border" >
                                    <div className="client-mobile-title">Бренд</div>
                                    <span
                                        className="list-item-text__normal">{item.brand}</span>
                                </div>
                                <div className="td2-4 list-item-border">
                                    <div className="client-mobile-title">ШК</div>
                                    <span className="list-item-text__normal">{item.barcode}</span>
                                </div>
                                <div className="td2-2 list-item-border">
                                    <div className="client-mobile-title">Артикул</div>
                                    <span className="list-item-text__normal">{item.productcode}</span>
                                </div>

                                <div className="td2-2 list-item-border" >
                                    <div className="client-mobile-title">Ссылка</div>
                                    <Link  to={"/card/" + item.code} style={{ textDecoration: 'underline' }} >
                                        <span className="list-item-text__normal" style={{ width: '300px' }}>Перейти</span>
                                    </Link>

                                </div>


                            </div>
                        </>
                    ))
                        : (<p className="search-on-page__text"> список пуст</p>)}
                </div>

            </>);
    }
}
